"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _Button = _interopRequireWildcard(require("../Button/Button"));

var _Modal = require("./Modal.styles");

var _elements = require("../../styles/elements");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ModalButton = function ModalButton(_ref) {
  var children = _ref.children,
      type = _ref.type,
      className = _ref.className,
      Tag = _ref.as,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "type", "className", "as"]);

  if (type === 'link') {
    return (0, _jsxRuntime.jsx)(Tag, _objectSpread(_objectSpread({
      className: (0, _clsx["default"])('grui', className),
      type: "button",
      css: [_elements.button.styles.preflight, _Modal.styles.link, process.env.NODE_ENV === "production" ? "" : ";label:ModalButton;"]
    }, otherProps), {}, {
      children: children
    }));
  }

  return (0, _jsxRuntime.jsx)(_Button["default"], _objectSpread(_objectSpread({
    size: "xBig"
  }, otherProps), {}, {
    as: Tag,
    type: type,
    css: [_Modal.styles.button, type === 'tertiary' && _Modal.styles.color, process.env.NODE_ENV === "production" ? "" : ";label:ModalButton;"],
    className: className,
    children: children
  }));
};

ModalButton.propTypes = {
  as: _propTypes.elementType,
  children: _propTypes.node,
  type: (0, _propTypes.oneOf)([].concat((0, _toConsumableArray2["default"])(_Button.buttonTypes), ['link'])),
  className: _propTypes.string
};
ModalButton.defaultProps = {
  as: 'button',
  children: undefined,
  type: 'info',
  className: undefined
};
var _default = ModalButton;
exports["default"] = _default;
//# sourceMappingURL=Button.js.map